<template>
  <SettingsPagePanel>
    <AccountEditorHeader />
    <SettingsTable>
      <SettingsTableRow name="プラン">
        <div :class="$style.plan">
          <PlanChip :plan="viewer.plan" />
        </div>
      </SettingsTableRow>

      <SettingsTableRow v-if="partnerChannels.length > 0" name="オプション">
        <ul :class="$style.channel">
          <li v-for="channel in partnerChannels" :key="channel.id">
            <ChannelChip :channel="channel.id" />
          </li>
        </ul>
      </SettingsTableRow>

      <SettingsTableRow name="ロール">
        <p :class="$style.text">{{ roleText }}</p>
      </SettingsTableRow>
    </SettingsTable>
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import SettingsTable from '@/pages/SettingsPage/SettingsTable/SettingsTable.vue'
import SettingsTableRow from '../SettingsTable/SettingsTableRow.vue'

import AccountEditorHeader from './AccountEditorHeader.vue'
import type { Account } from '@/types/app'

import type { AccountEditorTableViewerFragment } from './AccountEditorTable.generated'
import PlanChip from '@/features/plan/components/PlanChip.vue'
import ChannelChip from '@/components/atoms/ChannelChip.vue'
import { getPlannerRole } from '@/entityHandlers/getPlannerRole'
import { isPartnerChannel } from '@/models/channel/channel'
import SettingsPagePanel from '../SettingsPagePanel.vue'

const props = defineProps<{
  account: Account
  viewer: AccountEditorTableViewerFragment
}>()

const roleText = computed(() => {
  switch (getPlannerRole(props.account)) {
    case 'corporate_admin':
      return '企業管理者'
    case 'branch_manager':
      return '支店管理者'
    default:
      return 'スタッフ'
  }
})

const partnerChannels = computed(() =>
  props.viewer.channels.filter(value => isPartnerChannel(value.id))
)
</script>

<style lang="scss" module>
.text {
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;

  &:nth-child(n + 2) {
    margin-left: 16px;
  }
}

.channel {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.plan {
  display: flex;

  &__icon {
    width: 28px;
  }

  &__text {
    color: $color-text-and-object-high-emphasis;
    font-size: 16px;
    line-height: 28px;

    &:nth-child(n + 2) {
      margin-left: 6px;
    }
  }
}
</style>
